import * as React from 'react'
import { Consumer } from './Context'
import { ToasterConsumerProps } from './interface'

const ToasterConsumer: React.FC<ToasterConsumerProps> = ({ children }) => (
  <Consumer>{(context) => children(context)}</Consumer>
)

export default ToasterConsumer
